import { routes } from "../../../constants";
import { baseRouteMaker } from "../../../constants/routeConsts";
import i18n from "../../../i18n/i18n";

export const usePushNotificationMenuUtils = () => {
  const tempMenuGroup = [];

  /* menuItemSend */
  const menuItemSend = {
    id: "send",
    title: i18n.t("Modules.addOns.send"),
    url: baseRouteMaker(routes.SEND_PUSH_NOTIFICATION),
  };
  tempMenuGroup.push(menuItemSend);
  /* menuItemSend */

  /* menuItemSent */
  const menuItemSent = {
    id: "sent",
    title: i18n.t("Modules.addOns.sent"),
    url: baseRouteMaker(routes.SENT_PUSH_NOTIFICATION_LIST),
  };
  tempMenuGroup.push(menuItemSent);
  /* menuItemSent */

  return tempMenuGroup;
};
